// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "map" + "." + "4f90d70a56ddac93e45b" + ".min.css";
};